interface LanguageConfig {
  name: string;
  display: string;
  short: string;
}

interface AuthorizationConfig {
  Auth: {
    cognitoDomain: string | undefined;
    userPoolId: string | undefined;
    userPoolWebClientId: string | undefined;
  };
}

interface DefaultConfig {
  authorization: AuthorizationConfig;
  i18n: {
    fallbackLocale: string;
    languages: LanguageConfig[];
    selectedLanguage: string | null;
    supportedLanguages: string[];
  };
  timezone: {
    default: string;
  };
  defaultBusinessCountries: string[];
}

const { VITE_COGNITO_DOMAIN, VITE_COGNITO_POOL_ID, VITE_COGNITO_CLIENT_ID } =
  import.meta.env;

const defaultConfig: DefaultConfig = {
  authorization: {
    Auth: {
      cognitoDomain: VITE_COGNITO_DOMAIN,
      userPoolId: VITE_COGNITO_POOL_ID,
      userPoolWebClientId: VITE_COGNITO_CLIENT_ID
    }
  },
  i18n: {
    fallbackLocale: 'en',
    languages: [
      {
        name: 'British English',
        display: 'en',
        short: 'en'
      },
      {
        name: 'Čeština',
        display: 'cs',
        short: 'cs'
      },
      {
        name: 'Dansk',
        display: 'da',
        short: 'da'
      },
      {
        name: 'Deutsch',
        display: 'de',
        short: 'de'
      },
      {
        name: 'English US',
        display: 'en (US)',
        short: 'en_US'
      },
      {
        name: 'Español',
        display: 'es',
        short: 'es'
      },
      {
        name: 'Français',
        display: 'fr',
        short: 'fr'
      },
      {
        name: 'Français canadien',
        display: 'fr (CA)',
        short: 'fr_CA'
      },
      {
        name: 'Italiano',
        display: 'it',
        short: 'it'
      },
      {
        name: 'Magyar',
        display: 'hu',
        short: 'hu'
      },
      {
        name: 'Hrvatski',
        display: 'hr',
        short: 'hr'
      },
      {
        name: 'Nederlands',
        display: 'nl',
        short: 'nl_NL'
      },
      {
        name: 'Polski',
        display: 'pl',
        short: 'pl'
      },
      {
        name: 'Română',
        display: 'ro',
        short: 'ro'
      },
      {
        name: 'Slovensky',
        display: 'sk',
        short: 'sk'
      },
      {
        name: 'Slovenčina',
        display: 'sl',
        short: 'sl'
      },
      {
        name: 'Srpski',
        display: 'sr (Latn)',
        short: 'sr_Latn'
      }
    ],
    selectedLanguage: localStorage.getItem('sesc.selectedLanguage'),
    supportedLanguages: [
      'cs',
      'da',
      'de',
      'en',
      'en_US',
      'es',
      'fr',
      'fr_CA',
      'hu',
      'hr',
      'it',
      'nl_NL',
      'pl',
      'ro',
      'sk',
      'sl',
      'sr_Latn'
    ]
  },
  timezone: {
    default: 'Europe/Berlin'
  },
  defaultBusinessCountries: [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO',
    'CH',
    'AL',
    'ME',
    'MK',
    'RS',
    'TR',
    'AD',
    'BA',
    'MD',
    'MC',
    'SM',
    'UA',
    'GB',
    'VA',
    'CA',
    'MX',
    'US'
  ]
};

export default defaultConfig;
